module.exports = __webpack_public_path__ + "img/mapBottom1.4e908cad.png";